import Decimal from 'decimal.js';

export const toDecimal = (value) => {
    try {
        return new Decimal(value ?? 0);
    } catch (error) {
        return new Decimal(0);
    }
};

export const toMoneyNumber = (value) =>
    Number(
        toDecimal(value)
            .toDecimalPlaces(2, Decimal.ROUND_DOWN)
            .toString()
    );

export const getProductTaxPercent = (product) =>
    Number(
        product?.productTaxPercent ??
            product?.taxPercent ??
            product?.taxPercentage ??
            product?.gstPercent ??
            product?.gstPercentage ??
            0
    );

export const calculateTaxAmount = (
    rateInput,
    quantityInput,
    taxPercentInput
) => {
    const rate = toDecimal(rateInput);
    const quantity = toDecimal(quantityInput);
    const taxPercent = toDecimal(taxPercentInput);

    const taxable = rate
        .mul(quantity)
        .toDecimalPlaces(2, Decimal.ROUND_DOWN);

    const taxAmount = taxable
        .mul(taxPercent)
        .div(100)
        .toDecimalPlaces(2, Decimal.ROUND_DOWN);

    const grandTotal = taxable
        .add(taxAmount)
        .toDecimalPlaces(2, Decimal.ROUND_DOWN);

    return {
        taxable: Number(taxable.toString()),
        taxAmount: Number(taxAmount.toString()),
        grandTotal: Number(grandTotal.toString())
    };
};

export const aggregateCartTaxSummary = (cart = []) =>
    cart.reduce(
        (summary, cartItem) => ({
            taxable: toMoneyNumber(
                toDecimal(summary.taxable).plus(
                    toDecimal(cartItem?.taxable || 0)
                )
            ),
            taxAmount: toMoneyNumber(
                toDecimal(summary.taxAmount).plus(
                    toDecimal(cartItem?.taxAmount || 0)
                )
            ),
            grandTotal: toMoneyNumber(
                toDecimal(summary.grandTotal).plus(
                    toDecimal(
                        cartItem?.grandTotal ??
                            cartItem?.totalPrice ??
                            0
                    )
                )
            )
        }),
        {
            taxable: 0,
            taxAmount: 0,
            grandTotal: 0
        }
    );
